import React from 'react';
import classnames from 'classnames';

export const CardContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
	children,
	className,
}) => {
	return <div className={classnames('card-container', className)}>{children}</div>;
};

export const CardTitle: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({
	children,
	className,
}) => {
	return <h3 className={classnames('card-title', className)}>{children}</h3>;
};

export const CardText: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({
	children,
	className,
}) => {
	return <p className={classnames('card-text', className)}>{children}</p>;
};

export const CardIcon: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
	src,
	className,
	...props
}) => {
	return <img className={classnames('card-icon', className)} src={src} {...props} />;
};

export interface CardProps {
	link?: string;
}

const Card: React.FC<CardProps> = ({ children, link }) => {
	return (
		<a href={link} target="_blank" className="card">
			{children}
		</a>
	);
};

export default Card;
